import GenericRequest, { METHOD_GET } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export class ContractorsDetailCurrentRequest extends GenericRequest {

    request;

    constructor() {
        super(METHOD_GET, ApiEndpoints.CONTRACTORS_DETAIL_CURRENT);
        this.request = {};
    }

    overrideRequest() {
        return this.request;
    }

}



// WEBPACK FOOTER //
// ./src/app/contractors/ws/ContractorsDetailCurrentRequest.js